import React from 'react';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import { ThemeProvider, CssBaseline, Box, Button, Typography } from '@mui/material';
import '@aws-amplify/ui-react/styles.css';
import awsConfig from './aws-config';
import theme from './theme';
import Dashboard from './Dashboard';

Amplify.configure(awsConfig);

const authComponents = {
  Header() {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography sx={{ fontFamily: '"Fraunces", serif', fontSize: '2rem', fontWeight: 700, color: '#4edba1', letterSpacing: '-0.02em' }}>
          NCLEX Prep
        </Typography>
        <Typography sx={{ color: '#8b99b0', fontSize: '0.9rem', mt: 0.5 }}>
          Personalized nursing exam preparation
        </Typography>
      </Box>
    );
  },
};

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{
        minHeight: '100vh',
        background: 'radial-gradient(ellipse at 20% 0%, rgba(78,219,161,0.06) 0%, transparent 60%), radial-gradient(ellipse at 80% 100%, rgba(110,181,255,0.04) 0%, transparent 60%), #0a1628',
      }}>
        <Authenticator components={authComponents}
          formFields={{
            signUp: { email: { label: 'Email', placeholder: 'you@nursing.edu', order: 1 }, password: { label: 'Password', placeholder: '••••••••', order: 2 } },
          }}>
          {({ signOut, user }) => (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 3, pt: 2 }}>
                <Button onClick={signOut} size="small" sx={{ color: 'text.secondary', fontSize: '0.78rem', '&:hover': { color: 'error.main' } }}>
                  Sign Out
                </Button>
              </Box>
              <Dashboard user={user} />
            </>
          )}
        </Authenticator>
      </Box>
    </ThemeProvider>
  );
}
